"use client";

import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "@scott/ui/client";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const labelVariants = cva("font-medium text-sm leading-none");

const Label = ({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants> & {
    ref?: React.RefObject<React.ElementRef<typeof LabelPrimitive.Root> | null>;
  }) => (
  <LabelPrimitive.Root
    className={cn(labelVariants(), className)}
    ref={ref}
    {...props}
  />
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
